@import '../../assets/styles/components.css';

@layer components {
  :host {
    @apply align-middle inline-block;

    a,
    button {
      @apply font-bold leading-4 no-underline rounded text-sm;
      @apply inline-flex items-center justify-center px-4 py-2;
      @apply duration-150 ease-out transition;
      @apply focus:outline-none focus:ring focus:ring-primary-200;
    }

    abds-icon {
      @apply first:mr-1 last:ml-1;
    }

    &([appearance='outline']) {
      a,
      button {
        @apply border-2 border-solid px-4-border-2 py-2-border-2;
      }
    }

    &([palette='brand']) {
      a,
      button {
        @apply bg-brand text-neutral-lightest;
        @apply hover:bg-brand-600;
        @apply active:bg-brand-700;
      }
    }

    &([appearance='transparent'][palette='brand']) {
      a,
      button {
        @apply bg-transparent text-brand;
        @apply hover:text-brand-600;
        @apply active:text-brand-700;
      }
    }

    &([appearance='outline'][palette='brand']) {
      a,
      button {
        @apply bg-neutral-lightest border-brand text-brand;
        @apply hover:bg-brand-50 hover:border-brand-600 hover:text-brand-600;
        @apply active:bg-brand-100 active:border-brand-700 active:text-brand-700;
      }
    }

    &([palette='destructive']) {
      a,
      button {
        @apply bg-danger text-neutral-lightest;
        @apply hover:bg-danger-600;
        @apply active:bg-danger-700;
      }
    }

    &([appearance='outline'][palette='destructive']) {
      a,
      button {
        @apply bg-neutral-lightest border-danger;
        @apply hover:bg-danger-50 hover:border-danger-600;
        @apply active:bg-danger-100 active:border-danger-700;
      }
    }

    &([appearance='outline'][palette='destructive']),
    &([appearance='transparent'][palette='destructive']) {
      a,
      button {
        @apply text-danger;
        @apply hover:text-danger-600;
        @apply active:text-danger-700;
      }
    }

    &([palette='inverse']) {
      a,
      button {
        @apply border-neutral-lightest text-neutral-lightest;
        @apply hover:bg-neutral-lightest hover:text-brand-600;
        @apply active:bg-neutral-light active:border-neutral-light active:text-brand-700;
      }
    }

    &([palette='neutral']) {
      a,
      button {
        @apply bg-neutral-lightest border-secondary-200 text-brand;
        @apply hover:bg-brand-50 hover:text-brand-600 hover:border-secondary-300;
        @apply active:bg-brand-100 active:text-brand-700 active:border-secondary-400;
      }
    }

    &([palette='success']) {
      a,
      button {
        @apply bg-success border-transparent text-neutral-dark;
        @apply hover:bg-success-600 hover:text-neutral-darkest;
        @apply active:bg-success-700 active:text-neutral-lightest;
      }
    }

    &([appearance='transparent'][palette='success']) {
      a,
      button {
        @apply text-success;
      }
    }

    &([appearance='transparent'][palette='brand']),
    &([appearance='transparent'][palette='destructive']),
    &([appearance='transparent'][palette='inverse']),
    &([appearance='transparent'][palette='neutral']),
    &([appearance='transparent'][palette='success']) {
      a,
      button {
        @apply bg-transparent;
      }
    }

    &([width='full']) {
      @apply w-full;

      a,
      button {
        @apply w-full;
      }
    }

    &([disabled]) {
      @apply pointer-events-none;

      a,
      button {
        @apply bg-neutral-lightest border-neutral-lightest text-secondary-100;
      }
    }

    &([disabled][appearance='outline']),
    &([disabled][palette='neutral']) {
      a,
      button {
        @apply bg-neutral-lightest border-secondary-100 text-secondary-100;
      }
    }

    &([disabled][palette='brand']:not([appearance='outline'])),
    &([disabled][palette='destructive']:not([appearance='outline'])),
    &([disabled][palette='inverse']),
    &([disabled][palette='success']:not([appearance='outline'])) {
      a,
      button {
        @apply bg-secondary-100 border-secondary-100 text-neutral-lightest;
      }
    }

    &([appearance='transparent'][disabled][palette='brand']) {
      a,
      button {
        @apply bg-transparent text-secondary-100;
      }
    }
  }
}
